import React, { useState } from "react";
import "./styles.scss";
import {
  Account,
  Button,
  Footer,
  IconContainer,
  Link,
  LogoComponent,
  Number,
  Tags,
  TextBox,
} from "../../components";
import ProductCard from "../../components/ProductCard";
import Setupstaff from "../../components/Setupstaff";

const DesignSystemComponent = (props) => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isSelect, setIsSelect] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [education, setEducation] = useState("");
  const [expertise, setExpertise] = useState("");
  const [availability, setAvailability] = useState("");

  //TextBox
  const [defaultInput, setDefaultInput] = useState(""); // Default input
  const [validInput, setValidInput] = useState("Valid value"); // Valid input
  const [errorInput, setErrorInput] = useState("Invalid value"); // Error input
  const [disabledInput, setDisabledInput] = useState("Disabled value"); // Disabled input

  return (
    <>
      <div className={"container-wrapper-ds"}>
        <div className={"section-wrapper"}>
          <div className={"h4"}>Button</div>
          <div className="btnw-name">Primary</div>
          <div className="btn-wrapper">
            {/* button 1 */}
            <Button
              data={{
                btnName: "Sign up",
                buttonType: "primary",
                buttonSize: "sm",
                isLoading: false,
              }}
              // onClick={ () => {}}
            />

            {/* button 2 */}
            <Button
              data={{
                btnName: "Sign up",
                buttonType: "primary disabled",
                buttonSize: "sm",
                isLoading: false,
              }}
              // onClick={ () => {}}
            />

            {/* button 3 */}

            <Button
              data={{
                btnName: "Please wait",
                buttonType: "primary disabled",
                buttonSize: "sm",
                isLoading: false,
              }}
              // onClick={ () => {}}
            />
          </div>
          <div className="btnw-name">Secondary</div>
          <div className="btn-wrapper">
            <Button
              data={{
                btnName: "Sign up",
                buttonType: "secondary",
                buttonSize: "sm",
                isLoading: false,
              }}
              // onClick={ () => {}}
            />
            {/* button2 */}
            <Button
              data={{
                btnName: "Sign up",
                buttonType: "secondary disabled",
                buttonSize: "sm",
                isLoading: false,
              }}
              // onClick={ () => {}}
            />
          </div>
        </div>

        {/*logo*/}
        <div className={"section-wrapper"}>
          <div className={"h4"}>Logo Component</div>
          <LogoComponent />
        </div>

        {/*account*/}
        <div className={"section-wrapper"}>
          <div className={"h4"}>Account</div>
          <Account />
        </div>
      </div>
      {/* Input Field Section */}
      <div className={"section-wrapper"}>
        <div className={"h4"}>TextBox</div>

        <div className="input-field-example">
          <div className="inputw-name"></div>
          <TextBox
            data={{
              label: "Store name",
              placeholder: "Store name",
              value: defaultInput,
              status: "default",
            }}
            //onChange={handleInputChange(setDefaultInput)}
          />
        </div>

        <div className="input-field-example">
          <div className="inputw-name"></div>
          <TextBox
            data={{
              label: "Store name",
              placeholder: "Store name",
              value: validInput,
              status: "valid",
            }}
            //onChange={handleInputChange(setValidInput)}
          />
        </div>

        <div className="input-field-example">
          <div className="inputw-name"></div>
          <TextBox
            data={{
              label: "Store name",
              placeholder: "Store name",
              value: errorInput,
              status: "error",
              errorMessage: "Error goes here...",
            }}
            //onChange={handleInputChange(setErrorInput)}
          />
        </div>

        <div className="input-field-example">
          <div className="inputw-name"></div>
          <TextBox
            data={{
              label: "Store name",
              placeholder: "Store name",
              value: disabledInput,
              status: "disabled",
              disabled: true,
            }}
            //onChange={() => {}} // Disabled field doesn't need onChange handler
          />
        </div>
      </div>

      <div className="section-wrapper">
        <div className="h4">Icon Component</div>
        <IconContainer data={{ status: "success", iconType: "search" }} />
      </div>

      <div className="section-wrapper">
        <div className="h4">Form </div>
        <Link />
      </div>

      <div className="section-wrapper">
        <div className={"h4"}>Tags</div>
        <Tags /> {/* Integrating TagContainer */}
      </div>

      <div className="section-wrapper">
        <div className="h4">Number Circle Component</div>
        <Number data={{ number: 1, status: "active" }} />
        <br></br>
        <Number data={{ number: 2, status: "inactive" }} />
      </div>

      <div>
        {/* <div className="section-wrapper">
          <div className="h4">Location Setup Example</div>
          <Setuplocation />
        </div> */}
        <div className="section-wrapper">
          <div className="h4">Staff Setup Example</div>
          <Setupstaff />
        </div>
      </div>

      {/* productCard */}
      <div>
        <div className="section-wrapper">
          <div
            style={{
              display: "flex",
              gap: 24,
              flexWrap: "wrap",
              padding: "2rem",
            }}
          >
            <ProductCard
              image="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400"
              name="Bose QuietComfort 45 Wireless Headphones"
              desc="Headphones"
              price={279}
              originalPrice={349}
              rating={4.6}
              reviewCount={218}
              badge="discount"
              discountPercent={20}
            />
            <ProductCard
              image="https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=400"
              name="Sony WF-1000XM5 True Wireless Earbuds"
              price={299}
              rating={4.2}
              reviewCount={84}
              badge="new"
            />
          </div>
        </div>
      </div>

      {/*signupfooter*/}
      <div className={"section-wrapper"}>
        <div className={"h4"}>Signup Footer</div>
        <Footer />
      </div>
    </>
  );
};

export default DesignSystemComponent;
